import { ArrowLeft, Save, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useAppSelector } from "@/hooks/types";
import { getIs1TemplateTenant } from "@/store/tenant/selectors";

interface AdminHeaderProps {
    title: string;
    onBack: () => void;
    onDelete?: () => void;
    showDelete?: boolean;
    onSave?: () => void;
}

export const AdminHeader = ({
    title,
    onBack,
    onDelete,
    showDelete,
    onSave,
}: AdminHeaderProps) => {
    const is1TemplateTenant = useAppSelector(getIs1TemplateTenant);
    return (
        <div className="border-b bg-admin-card">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="flex h-16 items-center justify-between">
                    <div className="flex items-center space-x-4">
                        <Button
                            variant="ghost"
                            size="sm"
                            onClick={onBack}
                            className="flex items-center space-x-2 text-admin-primary"
                        >
                            <ArrowLeft className="h-4 w-4" />
                            <span>Back</span>
                        </Button>
                        <Separator
                            orientation="vertical"
                            className="h-6"
                        />
                        <h1 className="text-xl font-semibold text-admin-card-foreground">
                            {title}
                        </h1>
                    </div>
                    <div className="flex items-center space-x-2">
                        {onDelete && showDelete && is1TemplateTenant && (
                            <Button
                                variant="destructive"
                                size="sm"
                                onClick={onDelete}
                                className="text-admin-destructive-foreground"
                            >
                                <Trash2 className="h-4 w-4" />
                                Delete
                            </Button>
                        )}
                        {onSave && (
                            <Button
                                variant="default"
                                size="sm"
                                onClick={onSave}
                            >
                                <Save className="h-4 w-4" />
                                Save
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
